import { memo } from 'react';
import { useRecoilValue } from 'recoil';

import * as K from 'common/constants';
import { HELP_ROUTE } from 'components/help/constants';
import { routeState } from 'components/common/Managers/RouteStateManager.state';

// components
import AuthPage from 'components/auth/AuthPage';
import AcceptLinkInvitePage from 'components/acceptInviteLink/AcceptLinkInvitePage';
import ChangePasswordPublicPage from 'components/changePasswordPublic/ChangePasswordPublicPage';
import SignUpPageInternal from 'components/auth/SignUpPageInternal';
import HelpPage from 'components/help/HelpPage';
import PageNotFound, { PAGE_VARIANT as PAGE_NOT_FOUND_VARIANT } from 'components/other/404/PageNotFound';
import SSOInvite from 'components/auth/SSOInvite';

const router: Record<K.PUBLIC_ROUTE, JSX.Element> = {
  [K.ROUTE.ACCEPT_LINK_INVITE]: <AcceptLinkInvitePage />,
  [K.ROUTE.PAGE_NOT_FOUND]: <PageNotFound />,
  [K.ROUTE.PASSWORD_RESET]: <ChangePasswordPublicPage />,
  [K.ROUTE.SIGN_UP_INTERNAL]: <SignUpPageInternal />,
  [K.ROUTE.HELP]: <HelpPage />,
  [K.ROUTE.SSO_INVITE]: <SSOInvite />,
};

function PublicRouter(): JSX.Element {
  const route = useRecoilValue(routeState) as unknown as K.PUBLIC_ROUTE;

  let page = router[route];
  if (Object.values(HELP_ROUTE).includes(route as unknown as HELP_ROUTE)) {
    page = <HelpPage isPublic />;
  } else if (route === K.PUBLIC_ROUTE.PAGE_NOT_FOUND) {
    page = <PageNotFound variant={PAGE_NOT_FOUND_VARIANT.PUBLIC} />;
  }

  if (!page) {
    page = <AuthPage />;
  }

  return page;
}

// Router should never render because of a parent render. It should only render when its own internal state changes.
// This probably can be removed if we remove recoil-router, since suppressing those renders is its main purpose.
const alwaysTreatPropsAsEqual = (): boolean => true;

export default memo(PublicRouter, alwaysTreatPropsAsEqual);
